import { useEffect, useState } from 'react';
import { Column, Tab, TabPanel, Tabs, Typography } from '@tempmee/react';
import { TabBadge } from '../../TabBadge';
import { PendingReviewShiftsTab, TodayShiftsTab } from './components';
import { ActiveShiftTabEnum } from './enums';
import { useActiveShifts } from './hooks';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { EnforceOfficeDashboardV2 } from '~/constants/ff.posthog';
import {
  fireDashboardTodayShiftTabClicked,
  fireDashboardPendingReviewTabClicked,
} from '~/posthogs/events';

export const ActiveShift = () => {
  const { activeTab: defaultActiveTab, counters } = useActiveShifts();

  const [activeTab, setActiveTab] = useState<ActiveShiftTabEnum>(defaultActiveTab);

  const useOfficeDashboardV2 = useFeatureFlag(EnforceOfficeDashboardV2);

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  if (counters.todays === 0 && counters.reviews === 0) {
    return null;
  }

  return (
    <Column
      className="dashboard-active-shifts"
      py={6}
      px={12}
      data-cy="active-shifts-container"
    >
      {!useOfficeDashboardV2 && (
        <Typography
          as="span"
          bold
          size="heading_3"
          textAlign="center"
          data-cy="active-shifts-title"
          style={{ marginInline: 'auto' }}
        >
          Active Shifts
        </Typography>
      )}

      <Tabs
        defaultValue={ActiveShiftTabEnum.Today}
        value={activeTab}
        onChange={(tab) => {
          const typedTab = tab as ActiveShiftTabEnum;
          if (typedTab === ActiveShiftTabEnum.Today) fireDashboardTodayShiftTabClicked();
          if (typedTab === ActiveShiftTabEnum.PendingReview) fireDashboardPendingReviewTabClicked();
          setActiveTab(typedTab);
        }}
        style={{ alignItems: 'start', gap: 16, marginTop: 24, width: '100%' }}
        data-cy="active-shifts-tabs"
      >
        <Tab
          value={ActiveShiftTabEnum.Today}
          data-cy="todays-shifts-tab"
          label={
            <>
              Today&apos;s Professionals <TabBadge count={counters.todays || undefined} />
            </>
          }
        />
        <Tab
          value={ActiveShiftTabEnum.PendingReview}
          data-cy="pending-review-tab"
          label={
            <>
              Pending Review <TabBadge count={counters.reviews || undefined} activeColor="error" />
            </>
          }
        />
        <TabPanel
          value={ActiveShiftTabEnum.Today}
          style={{ width: '100%' }}
          data-cy="active-shifts-tab-panel"
        >
          <TodayShiftsTab />
        </TabPanel>
        <TabPanel value={ActiveShiftTabEnum.PendingReview} style={{ width: '100%' }}>
          <PendingReviewShiftsTab />
        </TabPanel>
      </Tabs>
    </Column>
  );
};
